export enum CourierLogisticsConfirmationEmailType {    
    Unknown = 0,
    PickupConfirmation = 1,
    DepartureConfirmation = 2,
    RecoveryConfirmation = 3,
    DeliveryConfirmation = 4,
    TenderedConfirmation = 5
}